import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiArrowRight } from "react-icons/hi";
import MetaTag from "../../components/MetaTag/MetaTag";
import SiteHeader from "../../site/SiteHeader";
import SiteFooter from "../../site/SiteFooter";
import { Eyebrow } from "../../site/Brand";
import "../../site/site.css";

const Error404 = () => {
  const { t } = useTranslation();
  return (
    <>
      <MetaTag title={t("seo.notFound.title")} description={t("seo.notFound.description")} noindex />
      <SiteHeader />
      <main className="page-head" style={{ paddingBottom: 120 }}>
        <div className="wrap">
          <Eyebrow line>404</Eyebrow>
          <h1 className="display">{t("seo.notFound.title").split(" | ")[0]}</h1>
          <p className="lead">{t("seo.notFound.description")}</p>
          <div className="hero__actions">
            <Link to="/" className="btn-pill">
              {t("site.nav.home")}
            </Link>
            <Link to="/properties" className="btn-pill btn-pill--ghost">
              {t("site.nav.catalog")} <HiArrowRight />
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
};

export default Error404;
